import React, { useEffect } from 'react'
import { debounce } from 'lodash'
import { Link } from 'gatsby'

import iconProductNbn from '../../assets/images/icon-product-nbn.svg'
import iconProductMobile from '../../assets/images/icon-product-mobile.svg'

import helper from '../../services/helper'

export const ShowcaseProducts = () => {
  useEffect(() => {
    syncHeights()
    registerResizeWatch()
    return () => {
      deRegisterResizeWatch()
    }
  }, [syncHeights])

  function syncHeights() {
    helper.syncHeights('.showcase-item p')
  }

  function registerResizeWatch() {
    const debouncedSyncHeights = debounce(syncHeights, 200, {
      leading: false,
      trailing: true,
    })
    window.addEventListener('resize', debouncedSyncHeights)
  }

  function deRegisterResizeWatch() {
    const debouncedSyncHeights = debounce(syncHeights, 200, {
      leading: false,
      trailing: true,
    })
    window.removeEventListener('resize', debouncedSyncHeights)
  }

  return (
    <section className="showcase showcase-product-offerings">
      <div className="container">
        <h1 className="banner-title">What are you looking for today?</h1>
        <div className="container">
          <div className="row justify-content-center">
            {/* <div className="col-md-6">
              <div className="showcase-item">
                <img
                  src={iconProductMobile}
                  alt="icon mobile"
                  className="product-mobile"
                />
                <h2>ANEX Mobile</h2>
                <p>
                  Simple mobile phone and data plans powered by the Optus 4G
                  network.
                </p>
                <Link
                  to="/mobile"
                  className="btn btn-xl btn-primary btn-orange btn-rounded fw-600"
                >
                  Go to mobile plans
                </Link>
              </div>
            </div> */}
            <div className="col-md-6">
              <div className="showcase-item">
                <img
                  src={iconProductNbn}
                  alt="icon nbn"
                  className="product-nbn"
                />
                <h2>Locality Energy nbn™</h2>
                <p>
                  High speed nbn™ plans with everything you need to keep your
                  home and business connected.
                </p>
                <Link
                  to="/nbn"
                  className="btn btn-xl btn-primary btn-orange btn-rounded fw-600"
                >
                  Go to nbn™ plans
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
